import React, { useEffect, useState } from 'react';
import { Container, Spinner, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import {
  Delete_One_Commission_Data_Action,
  Get_Commission_Data_For_Selected_Lead_Action,
} from '../Redux/Actions/Commission_Action';
import { FaEdit, FaTrash, FaProjectDiagram, FaUserTie, FaCalendarAlt } from 'react-icons/fa';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Notify } from '../Utility/Notify';
import { UpdateClientAction } from '../Redux/Actions/UsersAction';
import { useTheme } from '@mui/material';

export const LeadViewCommissionPage = () => {
  const theme = useTheme();
  const mode = theme.palette.mode; // جلب الوضع ال

  const { id } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const resleadselecteddata = useSelector((state) => state.AllCommissions.Add_Commission);
  const Commissions = resleadselecteddata?.data;

  useEffect(() => {
    const getleadcommissiondata = async () => {
      setLoading(true);
      await dispatch(Get_Commission_Data_For_Selected_Lead_Action(id));
      setLoading(false);
    };
    getleadcommissiondata();
  }, [dispatch, id]);

  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState(null); // لحفظ ID الكوميشن اللي هيتحذف

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setDeleteId(id);
    setShow(true);
  };
  const handledelete = async () => {
    if (deleteId) {
      await dispatch(Delete_One_Commission_Data_Action(deleteId));

      await dispatch(
        UpdateClientAction(id, {
          revenue: 0,
          review: false,
        }),
      );
      setTimeout(() => {
        Notify('success', 'Data Deleted Successfully', 'success');
        window.location.hash = '#/LeadsForAccountant';
      }, 1500);
      setShow(false); // قفل المودال بعد الحذف
    }
  };

  return (
    <Container
      className="startpage fade-in"
      style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}
    >
      {/* model for delete */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header
          closeButton
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Modal.Title>Modal Deleting Commission</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          Are you Sure For Deleting This Commission Process
        </Modal.Body>
        <Modal.Footer
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handledelete}>
            Yes I`am Sure
          </Button>
        </Modal.Footer>
      </Modal>
      <Link to={`/LeadsForAccountant`} style={{ textDecoration: 'none', color: '#0F7687' }}>
        <span style={{ fontWeight: 'bold' }}>Home</span>
      </Link>{' '}
      <KeyboardDoubleArrowRightIcon /> <span>Leads Commissions</span>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '50vh', color: mode === 'dark' ? '#90caf9' : '#0F7687' }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Row
          xs={1}
          md={2}
          lg={3}
          className="g-4 my-3 "
          style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}
        >
          {Array.isArray(Commissions) && Commissions.length > 0 ? (
            Commissions.map((item) => (
              <Col key={item._id} style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                <div
                  className="shadow-sm h-100 p-3 rounded border"
                  style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}
                >
                  <h5
                    className="text-primary mb-2"
                    style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}
                  >
                    <FaProjectDiagram className="me-2" />
                    {item?.project?.name || 'Project Name'}
                  </h5>

                  <Card.Subtitle
                    className="mb-2 text-muted"
                    style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}
                  >
                    <div style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <FaUserTie className="me-2" /> Developer: {item?.developer?.name}
                    </div>
                  </Card.Subtitle>

                  <hr />
                  <div style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                    <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <strong>Lead Name :</strong> {item?.lead?.name}
                    </p>
                    <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <strong>Unit Price:</strong> {item?.unitprice}
                    </p>
                    <hr />

                    <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <strong>Commission Rate:</strong> {item.commissionRate}%
                    </p>
                    <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <strong>Commission Value:</strong> {item.commissionValue.toLocaleString()} AED
                    </p>
                    <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <strong>Cashback (Company):</strong>{' '}
                      {item.companyCashbackValue.toLocaleString()} AED ({item.companyCashbackRate}%)
                    </p>
                    <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <strong>VAT:</strong> {item.vatValue} AED ({item.vatRate}%)
                    </p>
                    <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <strong>Final Balance:</strong>{' '}
                      <span className="text-success fw-bold">
                        {item.finalBalance.toLocaleString()} AED
                      </span>
                    </p>

                    <hr />
                    <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <strong>Sales:</strong> {item.sales} ({item.salesRate}% - {item.salesValue}{' '}
                      AED)
                    </p>
                    <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <strong>Marketer:</strong> {item.marketer} ({item.marketerRate}% -{' '}
                      {item.marketerValue} AED)
                    </p>
                    <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <strong>Team Leader:</strong> {item.teamleader} ({item.teamLeaderRate}% -{' '}
                      {item.teamLeaderValue} AED)
                    </p>
                    <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                      <strong>Manager:</strong> {item.manager} ({item.managerRate}% -{' '}
                      {item.managerValue} AED)
                    </p>
                  </div>
                  <hr />
                  <p style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
                    <FaCalendarAlt className="me-2" /> <strong>Payment Date:</strong>{' '}
                    {new Date(item.paymentDate).toLocaleDateString()}
                  </p>

                  <div className="d-flex justify-content-between mt-4">
                    <Link to={`/LeadUpdateCommission/${item._id}`}>
                      <Button>
                        <FaEdit className="me-2" /> Update
                      </Button>
                    </Link>
                    <Button onClick={() => handleShow(item._id)}>
                      <FaTrash className="me-2" /> Delete
                    </Button>
                  </div>
                </div>
              </Col>
            ))
          ) : (
            <Col>
              <div className="text-center text-muted">No Commissions Found For This Lead.</div>
            </Col>
          )}
        </Row>
      )}
      <div style={{ marginTop: '100px' }}></div>
    </Container>
  );
};
